import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getApiDefinitionBySlug } from '../../services/api-repositories/api-definitions-repository';
import { initialApiDetailState } from './types';
import { t } from 'i18next';

export const fetchApiDefinitionById = createAsyncThunk(
  'apiDetail/fetchApiDefinitionById',
  async (slug: string) => {
    return await getApiDefinitionBySlug(slug);
  },
);

const apiDetailSlice = createSlice({
  name: 'apiDetail',
  initialState: initialApiDetailState,
  reducers: {
    clearApiDetailError: (state) => {
      state.error = null;
    },
    clearCurrentApiDefinition: (state) => {
      state.currentApiDefinition = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApiDefinitionById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApiDefinitionById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentApiDefinition = action.payload;
      })
      .addCase(fetchApiDefinitionById.rejected, (state, action) => {
        state.loading = false;
        state.currentApiDefinition = null;
        state.error = action.error.message || t('errors.failedToFetchApiDefinition');
      });
  },
});

export const { clearApiDetailError, clearCurrentApiDefinition } = apiDetailSlice.actions;
export default apiDetailSlice.reducer;
